/**
 * Cookie
 * Contains methods to simplify cookie management.
 * @see {@link http://www.w3schools.com/js/js_cookies.asp}
 * @version 3.0.0
 */

/**
 * Sets a cookie.
 * @param {String} cname - The name of the cookie.
 * @param {String} cvalue - The value of the cookie.
 * @param {Number|Null} exdays - The number of days until the cookie should expire (can be null).
 * @param {String|Null} path - The path to set the cookie to (can be null).
 * @public
 */
export const setCookie = (cname, cvalue, exdays, path) => {
    let cookie = cname + '=' + cvalue;

    if (exdays && typeof exdays === 'number') {
        const expires = new Date();
        expires.setTime(expires.getTime() + (exdays * 86400000));
        cookie += '; expires=' + expires.toUTCString();
    }

    if (path && typeof path === 'string') {
        cookie += '; path=' + path;
    }

    document.cookie = cookie;
};

/**
 * Gets a cookie.
 * @param {String} cname - The name of the cookie.
 * @public
 */
export const getCookie = cname => {
    const m = document.cookie.match('(^|;)\\s*' + cname + '\\s*=\\s*([^;]+)');
    return (m && m.pop()) || '';
};
